import { render } from "./appoint-trust-coordinator-modal.html?vue&type=template&id=4a3020a6&scoped=true&ts=true&external"
import script from "./appoint-trust-coordinator-modal.ts?vue&type=script&lang=ts&external"
export * from "./appoint-trust-coordinator-modal.ts?vue&type=script&lang=ts&external"

import "./appoint-trust-coordinator-modal.scss?vue&type=style&index=0&id=4a3020a6&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3020a6"]])

export default __exports__